import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useListContext } from "react-admin";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { translateFromPresentation } from "@sequentech/ui-core";
import { StyledChip } from "./StyledChip";
import { stringifyFields } from "../services/RowClickService";
var DEFAULT_MAX = 10;
export var ChipList = function (_a) {
    var source = _a.source, filterFields = _a.filterFields, max = _a.max;
    var data = useListContext().data;
    var i18n = useTranslation().i18n;
    if (!data) {
        return null;
    }
    var handleClick = function (event) {
        event.stopPropagation();
    };
    return (_jsx(_Fragment, { children: data.slice(0, max || DEFAULT_MAX).map(function (element) { return (_jsx(Link, { to: {
                pathname: "/".concat(source, "/").concat(element.id),
                search: filterFields
                    ? "filter=".concat(stringifyFields(element, filterFields))
                    : undefined,
            }, onClick: handleClick, children: _jsx(StyledChip, { label: translateFromPresentation(element, "name", i18n.language, {
                    defaultLanguageCode: "en",
                }) }) }, element.id)); }) }));
};
